const news_categoryRouter = [
    {
        path: "list-news_category",
        name: "list",
        component: () => import("@/views/admin/news_category"),
        default: true,
        meta: {
            model: "news_category",
            // requiresAuth: true,
        },
    },
    {
        path: "list-news_category/add",
        name: "add",
        component: () => import("@/views/admin/news_category/function"),
        default: true,
        meta: {
            model: "news_category",
            // requiresAuth: true,
        },
    },
    {
        path: "list-news_category/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/news_category/function"),
        default: true,
        meta: {
            model: "news_category",
            // requiresAuth: true,
        },
    },
];
export default news_categoryRouter;